/**
 * The "no value" mark as a muted table cell.
 *
 * One component, so an empty cell looks the same in every table rather than
 * being a blank here and a differently-styled mark there. The mark itself
 * lives in `emptyValue`, which the pure view-model helpers share.
 */

import { EMPTY_CELL } from './emptyValue';

export function EmptyCell() {
  return <span className="hint">{EMPTY_CELL}</span>;
}
